import { render, staticRenderFns } from "./querypassword.vue?vue&type=template&id=d07cd6d6&scoped=true"
import script from "./querypassword.vue?vue&type=script&lang=js"
export * from "./querypassword.vue?vue&type=script&lang=js"
import style0 from "./querypassword.vue?vue&type=style&index=0&id=d07cd6d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07cd6d6",
  null
  
)

export default component.exports